import React, { useState, useEffect } from 'react';
import { string, func, object, bool } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { translate } from 'react-i18next';

import { BaseLocaleSelection } from '@snapask/common-components';
import cookie from '@snapask/common-components/dist/utils/cookie';
import {
  USER_LNG,
  HAS_CHOOSE_LOCALE,
} from '@snapask/common-components/dist/constants/cookieNames';
import { setBodyLanguage } from '@snapask/common-components/dist/services/language';

import config from '@dragonfruit/config';

import { fetchSiteInfo } from '@dragonfruit/redux/siteInfo';
import { saveLocale, getLocaleCode } from '@dragonfruit/redux/locale';
import { getToken } from '@dragonfruit/redux/auth';

function SnapaskLocaleSelection({
  isLoggedIn,
  t,
  changeLocale,
  currentLocale,
  i18n,
}) {
  const [open, setOpen] = useState(false);
  const snapCookie = new cookie(config.COOKIE_DOMAIN);

  useEffect(() => {
    const hasChooseLocale = snapCookie.readCookie(HAS_CHOOSE_LOCALE);
    if (!isLoggedIn && !hasChooseLocale) {
      setOpen(true);
    }
  }, [isLoggedIn, snapCookie]);

  const handleChangeLocale = (selectedLocale, lang) => {
    changeLocale({
      localeCode: selectedLocale,
      language: lang,
      region: selectedLocale.slice(-2),
    });

    snapCookie.setCookie(USER_LNG, lang);
    snapCookie.setCookie(HAS_CHOOSE_LOCALE, true);
    setOpen(false);

    setBodyLanguage(window, lang);

    fetchSiteInfo();

    i18n.changeLanguage(selectedLocale, () => {
      const path = location.pathname.replace(currentLocale, selectedLocale);
      location.pathname = path;
    });
  };

  return (
    <BaseLocaleSelection
      open={open}
      currentLocale={currentLocale}
      onSelectLocale={handleChangeLocale}
      t={t}
    />
  );
}

SnapaskLocaleSelection.propTypes = {
  changeLocale: func.isRequired,
  currentLocale: string.isRequired,
  i18n: object.isRequired,
  isLoggedIn: bool.isRequired,
  t: func.isRequired,
};

export default compose(
  translate(['navigation', 'onboarding']),
  connect(
    state => ({
      currentLocale: getLocaleCode(state),
      isLoggedIn: !!getToken(state),
    }),
    {
      changeLocale: saveLocale,
    }
  )
)(SnapaskLocaleSelection);



// WEBPACK FOOTER //
// ./app/components/SnapaskLocaleSelection/SnapaskLocaleSelection.jsx